import { forwardRef } from "react";

const ForwardRefWrapper = ({ children, tag }, ref) => {
  const Element = tag || 'div';

  return <Element ref={ref}>{children}</Element>
};

export default forwardRef(ForwardRefWrapper);
